import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import ShipmentSticker from './ShipmentSticker';
import SubtitlesIcon from '@mui/icons-material/Subtitles';

export default function ShipmentsStickersWindow({ open, onClose, shipments }) {
  const { t } = useTranslation('ui');

  return (
    <React.Fragment>
      <Modal open={open} onClose={onClose}>
        <ModalDialog variant="outlined" role="alertdialog">
          <DialogTitle>
            <SubtitlesIcon />
            {t('shipments.stickersWindowTitle')}
          </DialogTitle>
          <Divider />
          <ShipmentSticker shipments={shipments} />
          <DialogActions>
            <Button variant="plain" color="neutral" onClick={onClose}>
              {t('actions.close')}
            </Button>
          </DialogActions>
        </ModalDialog>
      </Modal>
    </React.Fragment>
  );
}